var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 4.2038L2.29358 8.90806C2.29358 8.9147 2.29191 8.92446 2.28857 8.93778C2.28531 8.95099 2.28357 8.96058 2.28357 8.96739V13.731C2.28357 13.9029 2.34645 14.052 2.47218 14.1775C2.59787 14.3031 2.74671 14.3663 2.91874 14.3663H6.72949V10.5553H9.27035V14.3664H13.0811C13.2531 14.3664 13.4021 14.3034 13.5276 14.1775C13.6534 14.0521 13.7164 13.903 13.7164 13.731V8.96739C13.7164 8.94097 13.7128 8.92102 13.7064 8.90806L7.9999 4.2038Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8895 7.83623L13.7162 6.03002V1.98091C13.7162 1.88835 13.6865 1.81222 13.6268 1.75264C13.5675 1.69313 13.4914 1.66338 13.3986 1.66338H11.4932C11.4005 1.66338 11.3245 1.69313 11.2648 1.75264C11.2054 1.81222 11.1756 1.88838 11.1756 1.98091V3.91611L8.75419 1.89151C8.54271 1.71948 8.29126 1.63348 8.00011 1.63348C7.70899 1.63348 7.45757 1.71948 7.24588 1.89151L0.110156 7.83623C0.0440079 7.88906 0.00775309 7.96018 0.00100963 8.04951C-0.00569907 8.13878 0.0174164 8.21674 0.0704255 8.28286L0.685714 9.01727C0.738723 9.07678 0.808104 9.11317 0.894135 9.12649C0.973562 9.13316 1.05299 9.10994 1.13242 9.05704L7.9999 3.33058L14.8674 9.057C14.9205 9.10316 14.9898 9.12621 15.0759 9.12621H15.1057C15.1916 9.11314 15.2608 9.0765 15.3141 9.01713L15.9295 8.28282C15.9824 8.21657 16.0056 8.13874 15.9987 8.04938C15.9919 7.96028 15.9555 7.88917 15.8895 7.83623Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBold);
export default __webpack_public_path__ + "static/media/homeBold.d974a694.svg";
export { ForwardRef as ReactComponent };